import React from 'react'
import { Link } from 'react-router-dom';
import Header from '../Components/Header';
import Divider from './../Images/divider.png';
import PostThumbnail from './../Images/post-thumbnail.png';
import PostThumbnail2 from './../Images/post-thumbnail2.png';
import PostThumbnail3 from './../Images/post-thumbnail3.png';
import ArticleImg from './../Images/article-img.png';
import ArticleImg2 from './../Images/article-img.png';
import Footer from '../Components/Footer';
import { AiFillLeftCircle } from "react-icons/ai";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

const BlogArticle = () => {
    return (
        <>
            <Header />


            <div className=" pt-90 mb-70">
                <div className="container-fluid">
                    <div className="bg-voilet mb-4 py-4">
                        <div className="container">
                            <div className="backward-links pb-4 d-flex align-items-center">
                                <Link className='back-link' to="/blog"><AiFillLeftCircle /></Link>
                                <span> <ButtonGroup className='btn-grp' aria-label="Basic example">
                                    <Button className='grp-btn1' variant="secondary">Tutorial</Button>

                                    <Button className='grp-btn2' variant="secondary">AUGust 13, 2021 </Button>
                                </ButtonGroup></span>
                            </div>
                            <div className="article-title">
                                <h1>Why should you consider buying a Residential Plot in Bangalore Post Corona?</h1>
                            </div>
                        </div>
                    </div>
                    <div className="article-img">
                        <img src={ArticleImg} alt="" />
                    </div>
                </div>
            </div>


            <div className="container ">
                <div className="main-title-3 mb-70">
                    <p> The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the Own Residence/Home in the Tier 1 City such as Bangalore.  The Covid-19 has made several people to lose the Jobs across the Country. No Salary or Half of the Salary provided by the Employers for the Working people had made the Situation worse for several Working People. Post Covid has shown a greater demand for the Residential Land/Plots across the Tier1 cities of India. As we have understood that the life is very uncertain after the Covid-19 Situation, The Financial Independence is mainly achieved when you are having your own Home. </p>
                    <p>According to a Real Estate Data, There is 25% increase in the purchase of the own home in the Tier1 Cities in 2022 compared to the 2021 data. The Costing of the Per Sq. Ft Constructed Residential home also has increased to 5800 Rs/- in Bangalore which is 8% higher than the 2021 year. The Other Tier1 and Tier2 Cities Price range also has increased from 6% to 9% this year 2022. Owning an Apartment or a Individual Home is better than dealing with the uncertainty of the rental homes in the tier1 cities. </p>


                </div>
                <div className="article-text d-flex flex-column align-items-center mb-70">
                    <div className="article-img-2">
                        <img src={ArticleImg2} alt="" />
                    </div>
                    <div className="article-img-caption">
                        <span>Image caption or credit</span>
                    </div>
                </div>
            </div>



            <div className="container">
                <div className="text-center mb-5">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>The Complete Vaccination has restored the Rental Income for the Homeowners</h1>
                        <p>The Complete Vaccination rollout has made the Working people to get back to their offices in the IT Hub Bangalore. This change over can bring the constant rental income to the property owners. </p>
                    </div>
                </div>
                <div className="text-center mb-5">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>The Home Loan Interest rates slashed</h1>
                        <p>To remind you, in May of this year, the Reserve Bank of India (RBI) cut the repo rate by 40 basis points, or from 4.4 percent to four percent, and further lowered the reverse repo rate to 3.35 percent. The action aided in lowering mortgage interest rates, which benefited buyers generally.</p>
                    </div>
                </div>
                <div className="text-center mb-5">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Booming Residential Real Estate Market after Corona</h1>
                        <p>It can be assumed that there won't be any fresh supply entering the market for a while given the slowdown in the building sector following the shutdown led by COVID-19. For the market to recover and the supply to pick up the pace, it could take a month or two. The next quarters may see an increase in real estate prices as demand outpaces supply. This indicates that if you invest now, you might soon benefit from an increase.<br />
                            Are you Looking to Invest in the Residential Plots?
                            <Link to="/contact">Connect with VISTAPLOTS</Link>.
                        </p>
                    </div>
                </div>


            </div>

            <div class="other-posts">
                <div class="container d-flex flex-column align-items-center">
                    <div class="interesting-posts py-50">
                        <div class="main-title-5 mb-60">
                            <h1>Other interesting posts</h1>
                        </div>
                        <div class="row mb-md-5 mb-4">
                            <div class="col-md-8 order-md-1 order-2">
                                <div class="other-txt">
                                    <div class="other-tags mb-3">
                                        <span className='art-tag1'>Weekly updates</span>
                                        <span className='art-tag2'>AUGust 13, 2021 </span>
                                    </div>
                                    <div class="other-heading">
                                        <h2>10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h2>
                                        <p>Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 order-md-2 order-1">
                                <div class="other-img mb-4">
                                    <img src={PostThumbnail} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-md-5 mb-4">
                            <div class="col-md-8 order-md-1 order-2">
                                <div class="other-txt">
                                    <div class="other-tags mb-3">
                                        <span className='art-tag1'>Weekly updates</span>
                                        <span className='art-tag2'>AUGust 13, 2021 </span>
                                    </div>
                                    <div class="other-heading">
                                        <h2>10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h2>
                                        <p>Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 order-md-2 order-1">
                                <div class="other-img mb-4">
                                    <img src={PostThumbnail3} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-md-5 mb-4">
                            <div class="col-md-8 order-md-1 order-2">
                                <div class="other-txt">
                                    <div class="other-tags mb-3">
                                        <span className='art-tag1'>Weekly updates</span>
                                        <span className='art-tag2'>AUGust 13, 2021 </span>
                                    </div>
                                    <div class="other-heading">
                                        <h2>10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h2>
                                        <p>Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 order-md-2 order-1">
                                <div class="other-img mb-4">
                                    <img src={PostThumbnail2} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default BlogArticle